module.exports = __webpack_public_path__ + "img/close_icon.2c71533e.svg";